import React, { useEffect } from 'react';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import { useParams } from 'react-router-dom';
import { renderHiddenElementPreviewIframe } from '../../../utils/utils';

function InfoDetail(props) {
  const { number } = useParams();

  const getBody = (index) => {
    let result = {
      namePath: '',
    };
    switch (index) {
      case 'info1': {
        result.namePath = 'infopage1_web.html';
        break;
      }
      case 'info2': {
        result.namePath = 'infopage2_web.html';
        break;
      }
      case 'info3': {
        result.namePath = 'infopage3_web.html';
        break;
      }
      case 'info4': {
        result.namePath = 'infopage4_web.html';
        break;
      }
      case 'info5': {
        result.namePath = 'infopage5_web.html';
        break;
      }
      case 'info6': {
        result.namePath = 'infopage6_web.html';
        break;
      }
      case 'info7': {
        result.namePath = 'infopage7_web.html';
        break;
      }
      case 'info8': {
        result.namePath = 'infopage8_web.html';
        break;
      }
    }

    return result;
  };

  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (event.origin.startsWith(process.env.RAZZLE_REACT_APP_DOMAIN_ADMIN) && event.data?.type === 'PREVIEW_DATA') {
        renderHiddenElementPreviewIframe(event.data?.classListHidden);
      }
    });
  }, []);

  const body = getBody(number);

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div style={{ maxWidth: 560, margin: 'auto' }}>
        <TopNav name="お知らせ_GitWebInfoDetail" hasBackIcon={true} hasHamburger={true} />
        <div style={{ paddingTop: '50px' }}>
          <iframe src={`/webview_web/Information/DetailInfo/${body.namePath}`} title="Help" />
        </div>
        <BottomNav />
      </div>
    </div>
  );
}

export default InfoDetail;
